import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest,
  DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getGuaranteeMoneyDepositsForAnOrganization = async (
  instance: AxiosInstance,
  params: DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getGuaranteeMoneyDepositsForOrganization(params)
}

export const getEarliestExpiringGuaranteeMoneyForOrganization = async (
  instance: AxiosInstance,
  params: DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getEarliestExpiringGuaranteeMoneyForOrganization(params)
}

// Do Not Remove this line ===@import api client===
